import moment from "moment";
export function kiloSeparator(x, numberDecimal = 0) {
    if (x !== 0) {
        if (!x) {
            return null;
        }
    }
    if (isNaN(x)) {
        return null;
    }

    if (numberDecimal > 0) x = Number(x).toFixed(numberDecimal);
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // return x;
}

export function emptyValidator(value, callback) {
    if (value == null) {
        callback(false);
        return;
    }

    if (value.length) {
        value = value.trim();
    }

    if (!value || 0 === value.length) {
        callback(false);
    } else {
        callback(true);
    }
}

export function absValidator(value, callback) {
    if (value == null) {
        callback(false);
        return;
    }

    if (value.length) {
        value = value.trim();
    }

    if (isNaN(value)) {
        callback(false);
        return;
    }

    if (value < 0 || 0 === value.length) {
        callback(false);
    } else {
        callback(true);
    }
}

export function getPipeMsg(msg) {
    let array_data = _.split(msg, "|");
    if (array_data.length > 1) {
        return array_data[1];
    } else {
        return msg;
    }
}

export function formatDate(value, format = "L") {
    moment.locale("id");
    return _.isNull(value) ? null : moment(value).format(format);
    // return value;
}
